// Cascade reel class
//
// Used to create, spin and animate reels
// Contains no logic.
// Set up reels as follows:
//
//    1 - reelmanager.createReel
//    2 - reelmanager.setSymbol to change initial symbols
//
// To use
//
//    1 - Set data using reelmanager.setData(arrayOfSymbolIndexes)
//    2 - reelmanager.startSpin()
//
//
// No injectors needed for this

cascadeReelTemplate = {};

cascadeReelTemplate.popAndDrop = function (symbolIndex, progress) {
  gameController.hideSymbolAnims();
  var progRad = cascadeReelTemplate.easingSubsequent(progress);
  var pos = this.currentYPos[symbolIndex];

  pos +=
    this.symbolDropDeltas[symbolIndex] *
    this.configParams.appertureSpacing *
    progRad;
  this.symbolSprites[symbolIndex].position.setY(pos);

  //set current position and force it back in the orientation change
  this.posForOrientation[symbolIndex] = pos;
};

cascadeReelTemplate.clearSymbols = function (symbolIndex, progress) {
  // Copy from above
  var progRad = cascadeReelTemplate.easing(progress);

  // if (symbolIndex == 0) {
  //   var pos = (symbolIndex + 0.5) * (this.configParams.appertureSpacing * 1.5);
  // } else {
  var pos = (symbolIndex + 0.5) * this.configParams.appertureSpacing;
  // }

  pos +=
    this.symbolDropDeltas[symbolIndex] *
    this.configParams.appertureSpacing *
    progRad;
  this.symbolSprites[symbolIndex].position.setY(pos);
  this.posForOrientation[symbolIndex] = pos;
};

cascadeReelTemplate.dropInitialSymbols = function (symbolIndex, progress) {
  // original no bounce
  var progRad = 1 - cascadeReelTemplate.easing(progress);

  // if (symbolIndex == 3) {
  // var pos = (symbolIndex + 0.5) * (this.configParams.appertureSpacing * 1.1);
  // } else {
  var pos = (symbolIndex + 0.5) * this.configParams.appertureSpacing;
  // }

  pos += -(
    this.symbolDropDeltas[symbolIndex] *
    this.configParams.appertureSpacing *
    progRad
  );
  this.symbolSprites[symbolIndex].position.setY(pos);
  this.posForOrientation[symbolIndex] = pos;
};

cascadeReelTemplate.easing = function (x) {
  const c1 = 1.70158;
  const c3 = c1 + 1;

  return c3 * x * x * x - c1 * x * x;
};

cascadeReelTemplate.easingSubsequent = function (x) {
  const c1 = 1.70158;
  const c3 = c1 + 1;

  return 1 + c3 * Math.pow(x - 1, 3) + c1 * Math.pow(x - 1, 2);
};

cascadeReelTemplate.getDefaultConfigParameters = function () {
  var params = {};
  params.appertureHeight = 3;
  params.preappertureSymbols = 1;
  params.postappertureSymbols = 0;
  params.totalAppertureSize =
    params.appertureHeight +
    params.preappertureSymbols +
    params.postappertureSymbols;

  params.useContainer = {};
  params.useContainer.child = false;

  params.animationStripWidth = 0;
  params.animationStripHeight = 0;

  params.popAndDropTime = 300;
  params.dropAllTime = 525;
  params.dropAllTimeFS = 400;
  params.dropSingleTime = 100;
  params.dropSingleTimeFS = 100;
  params.gapBetweenSymbols = 50;
  params.gapBetweenSymbolsFS = 50;

  params.autoUpdateClipRect = true;

  return params;
};

cascadeReelTemplate.getDefaultSpinParameters = function () {
  var params = {};

  // Acceleration and deceleration unit is "number of symbols"
  params.accelerationDistance = 0;
  params.decelerationDistance = 0;

  // Spin speed and land velocity are in symbols per second
  params.spinSpeed = 9;
  params.landVelocity = 0;

  params.useBounceAnimation = false;
  // Land sound
  params.landSound = undefined;

  // Post land animation
  params.landOffset = 0.25;
  params.landAlignTime = 250;

  params.reverseSpin = false;

  return params;
};

cascadeReelTemplate.setSpinParameters = function (params, json) {
  params.spinSpeed =
    typeof json.spinSpeed !== "undefined" ? json.spinSpeed : params.spinSpeed;
  params.landVelocity =
    typeof json.landVelocity !== "undefined"
      ? json.landVelocity
      : params.landVelocity;
  params.accelerationDistance =
    typeof json.accelerationDistance !== "undefined"
      ? json.accelerationDistance
      : params.accelerationDistance;
  params.decelerationDistance =
    typeof json.decelerationDistance !== "undefined"
      ? json.decelerationDistance
      : params.decelerationDistance;
  params.landOffset =
    typeof json.landOffset !== "undefined"
      ? json.landOffset
      : params.landOffset;
  params.landAlignTime =
    typeof json.landAlignTime !== "undefined"
      ? json.landAlignTime
      : params.landAlignTime;
  params.useBounceAnimation =
    typeof json.useBounceAnimation !== "undefined"
      ? json.useBounceAnimation
      : params.useBounceAnimation;
  params.landSound =
    typeof json.landSound !== "undefined" ? json.landSound : params.landSound;
  params.renderSymbolsOutOfView =
    typeof json.renderSymbolsOutOfView !== "undefined"
      ? json.renderSymbolsOutOfView
      : params.renderSymbolsOutOfView;

  if (Reflex.developerModeData.fastSpin) {
    params.spinSpeed = 9999;
    params.accelerationDistance = 0;
    params.decelerationDistance = 0;
    params.landAlignTime = 50;
  }

  return params;
};

cascadeReelTemplate.createReel = function (reelIndex, json, landedCallback) {
  // Create reel object
  var reel = new PIXI.Container();
  reel._stateData = {};

  reel.symbolData = [];
  reel.symbolSprites = [];
  reel.workingContainer = {};
  reel.dropBasePositions = [];

  reel.reelIndex = reelIndex;
  reel.spinning = false;
  reel.pos = 0;
  reel.preDelay = 0;

  reel.symbolDropDeltas = [];

  reel.linkedAnimations = [];
  reel.linkedReelBoxStrips = [];

  reel.currentYPos = [];

  reel.dropCount = 0;

  reel.dropInitialTimer = [];
  reel.symTimer = [];

  reel.clearTimer = [];
  reel.clearSymTimer = [];
  reel.reelDelayTimer = undefined;
  reel.clearDelayTimer = undefined;

  reel.posForOrientation = [];

  reel._landedCallback = landedCallback;

  reel._cascadeSounds = ["cascade1", "cascade2", "cascade3"];

  // The symbols template tells us all about the reel symbols
  var symbolTemplate = resourceManager.getConfiguration().symbols;
  var keys = Object.keys(symbolTemplate);

  // Get configuration parameters used for this template (cant change)
  reel.configParams = cascadeReelTemplate.getDefaultConfigParameters();
  if (typeof json.appertureHeight !== "undefined") {
    reel.configParams.appertureHeight = json.appertureHeight;
  }
  if (typeof json.preappertureSymbols !== "undefined") {
    reel.configParams.preappertureSymbols = json.preappertureSymbols;
  }
  if (typeof json.postappertureSymbols !== "undefined") {
    reel.configParams.postappertureSymbols = json.postappertureSymbols;
  }
  if (typeof json.popAndDropTime !== "undefined") {
    reel.configParams.popAndDropTime = json.popAndDropTime;
  }
  if (typeof json.dropAllTime !== "undefined") {
    reel.configParams.dropAllTime = json.dropAllTime;
  }

  if (typeof json.autoUpdateClipRect !== "undefined") {
    reel.configParams.autoUpdateClipRect = json.autoUpdateClipRect;
  }

  reel.configParams.totalAppertureSize =
    reel.configParams.preappertureSymbols +
    reel.configParams.appertureHeight +
    reel.configParams.postappertureSymbols;

  // Create spin parameters used for this reel (can change)
  reel.spinParams = cascadeReelTemplate.setSpinParameters.bind(reel)(
    cascadeReelTemplate.getDefaultSpinParameters(),
    json
  );

  var symbolTextures = textureParser.getTextureList("staticSymbols");
  var initialSymbols = [];
  for (var i = 0; i < reel.configParams.totalAppertureSize; ++i) {
    initialSymbols.push({
      symbolId: 0,
    });
  }

  // Create object to store all speed parameters neatly
  reel.speedData = {};
  reel.symbolLUT = {};

  // Create look up table
  for (var i = 0; i < keys.length; i++) {
    var symbolDef = symbolTemplate[keys[i]];
    reel.symbolLUT["ID" + symbolDef.ID] = i;
  }

  reel.saveState = function () {
    this._stateData = {};
    var keys = Object.getOwnPropertyNames(this);
    var keysToIgnore = Object.keys(new PIXI.Container());

    // These are all PIXI objects
    keysToIgnore.push("symbolSprites");
    keysToIgnore.push("linkedAnimations");
    keysToIgnore.push("linkedReelBoxStrips");
    keysToIgnore.push("symbolContainer");
    keysToIgnore.push("interactiveSymbolContainer");
    keysToIgnore.push("animationStripContainer");
    keysToIgnore.push("animationBoxContainer");
    keysToIgnore.push("workingContainer");

    // These arent saved change
    keysToIgnore.push("Props");
    keysToIgnore.push("stateMachine");
    keysToIgnore.push("phase");
    keysToIgnore.push("_stateData");
    // keysToIgnore.push("preInjector");
    //  keysToIgnore.push("postInjector");

    for (var i = 0; i < keysToIgnore.length; i++) {
      keys.splice(keys.indexOf(keysToIgnore[i]), 1);
    }

    for (var i = 0; i < keys.length; i++) {
      var name = keys[i];
      var type = typeof this[name];
      var isCallback = name.includes("callback") || name.includes("Callback");

      if (type !== "function" && name !== "base" && !isCallback) {
        if (checkForDefined(this[name])) {
          this._stateData[keys[i]] = JSON.parse(JSON.stringify(this[name]));
        } else {
          this._stateData[keys[i]] = undefined;
        }
      }
    }
  };

  reel.restoreState = function () {
    // ABORT FUNCTIONALITY - leave in in case somone changes thier mind

    // var keys = Object.keys(this._stateData);
    // for (var i = 0; i < keys.length; i++) {
    //     var name = keys[i];
    //     if (checkForDefined(this._stateData[name])) {
    //         this[name] = JSON.parse(JSON.stringify(this._stateData[name]));
    //     }
    //     else {
    //         this[name] = undefined;
    //     }
    // }

    // // Reset symbol sprites
    // for (var i = 0; i < this.symbolData.length; i++) {
    //     this.setReelSymbol(i - reel.configParams.preappertureSymbols, this.symbolData[i]);
    // }

    /////////////////////////////////////////////////////////////////////////////////////////////////////////

    // shut down all timers
    // timer for this reel to drop in

    if (this.clearDelayTimer !== undefined) {
      timerManager.stop(this.clearDelayTimer);
      this.clearDelayTimer = undefined;
    }

    // timers for each symbol to wait before drop
    for (var i = 0; i < this.clearTimer.length; i++) {
      if (this.clearTimer[i] !== undefined) {
        timerManager.stop(this.clearTimer[i]);
        this.clearTimer[i] = undefined;
      }
    }

    // timers for each symbol to drop into position
    for (var i = 0; i < this.clearSymTimer.length; i++) {
      if (this.clearSymTimer[i] !== undefined) {
        timerManager.stop(this.clearSymTimer[i]);
        this.clearSymTimer[i] = undefined;
      }
    }

    this.stateMachine.switchState("READY");
    this._stateData = {};
  };

  reel.clearReel = function (delay) {
    let self = this;

    // in view
    reel.symbolDropDeltas[0] = 3;
    reel.symbolDropDeltas[1] = 3;
    reel.symbolDropDeltas[2] = 3;

    // post
    reel.symbolDropDeltas[3] = 3;

    reel.dropCount = 4;

    for (var i = 0; i < this.symbolSprites.length; i++) {
      this.posForOrientation[i] = undefined;
    }

    this.clearDelayTimer = timerManager.addTimer(
      delay,
      function (progress) {},
      function () {
        self.stateMachine.switchState("CLEARSYMBOLS");
      }
    );
  };

  reel.fillInitialSymbols = function (delay, positions) {
    // need to swap out symbols with those in positions before dropping in
    let self = this;

    // in view
    reel.symbolDropDeltas[0] = 4;
    reel.symbolDropDeltas[1] = 4;
    reel.symbolDropDeltas[2] = 4;

    // post

    //reel.alpha = 0;

    reel.symbolDropDeltas[3] = 4;

    reel.setSymbol(0, positions[this.reelIndex][0]);
    reel.setSymbol(1, positions[this.reelIndex][1]);
    reel.setSymbol(2, positions[this.reelIndex][2]);

    reel.setSymbol(3, positions[this.reelIndex][3]);

    reel.dropCount = 4;

    for (var i = 0; i < this.symbolSprites.length; i++) {
      this.posForOrientation[i] = undefined;
    }

    // Move the non-visible symbols down so the oversized ones don't creep up onto the reels
    this.symbolSprites[0].position.setY(1000);

    this.reelDelayTimer = timerManager.addTimer(
      delay,
      function (progress) {},
      function () {
        self.stateMachine.switchState("DROPINITIALSYMBOLS");
      }
    );
  };

  reel.requestSlamStop = function () {
    // needs to put all symbols into final position
    // update symbols to correct final symbol
    // clear all timers that are in progress and reset states

    // landing call backs must all be called correctly too.

    // don't slam out pops - or special symbols

    // clear symbols
    // initial drop slamout only.

    // initial delay timers and symbols timers - stop timers - set progress to 100%

    // timer for this reel to drop in
    if (this.reelDelayTimer !== undefined) {
      timerManager.stop(this.reelDelayTimer);
      this.reelDelayTimer = undefined;
    }

    // timers for each symbol to wait before drop
    for (var i = 0; i < this.symTimer.length; i++) {
      if (this.symTimer[i] !== undefined) {
        timerManager.stop(this.symTimer[i]);
        this.symTimer[i] = undefined;
      }
    }

    // timers for each symbol to drop into position
    for (var i = 0; i < this.dropInitialTimer.length; i++) {
      if (this.dropInitialTimer[i] !== undefined) {
        timerManager.stop(this.dropInitialTimer[i]);
        this.dropInitialTimer[i] = undefined;
      }
    }

    // fire all the call backs and set drop count to zero
    for (var i = 3; i >= 0; i--) {
      this.dropInitialSymbols(i, 1);

      // we don't need to worry about the bottom most symbol as that never lands on screen
      if (i !== 3) {
        this._landedCallback(this.reelIndex, i);
      }
    }

    // force this here as we may not have made it into drop initial symbols
    this.stateMachine.switchState("READY");
    this.spinning = false;
    this.spinCompleteCallback(this.reelIndex);

    this.dropCount = 0;

    //reel.alpha = 1;
  };

  // reel.checkSlamStop = function() {
  //     if (this.slamStopRequested) {
  //         // // Get all remaining symbol out the injector. Note we dont have to create every symbol, so first dump everything that will go in the apperture
  //         // while (this.postInjector.remainingSymbols > (this.configParams.appertureHeight + this.configParams.preappertureSymbols + this.configParams.postappertureSymbols)) {
  //         //     this.postInjector.getNextSymbol(this.symbolData);
  //         // }

  //         // while (this.postInjector.remainingSymbols > 0) {
  //         //     this.getNextSymbolFromInjector(this.postInjector);
  //         // }

  //         // Update positions to rest
  //         this.pos = 0;
  //         this.updateSymbols();

  //         // Go to just landed state to continue
  //         this.stateMachine.switchState("JUST_LANDED");

  //         return true;
  //     };

  //     return false;
  // };

  reel.requestStop = function () {
    this.stopRequested = true;
  };

  reel.stop = function (positions, numberPreSymbols) {
    this.stateMachine.switchState("SPINNING");
    this.updatePos = cascadeReelTemplate.defaultSpin.bind(this);
  };

  reel.setSpinParameters = function (spinParameters) {
    // spin Parameters should be passed as an object
    cascadeReelTemplate.setSpinParameters.bind(this)(
      this.spinParams,
      spinParameters
    );
  };

  reel.spinDeceleratingCallback = function () {};

  reel.spinLandedCallback = function () {};

  reel.spinCompleteCallback = function () {};

  reel.initialDropCompleteCallback = function () {};

  reel.nudgeOnComplete = function () {};
  reel.Props = {};

  reel.Props.state = "READY";
  reel.Props.stateTime = 0;

  // Create data
  reel.symbolWidth = symbolTextures[0].width;
  reel.symbolHeight = symbolTextures[0].height;

  // These sizes are in standard layout space
  reelManager.symbolWidth = symbolTextures[0].width;
  reelManager.symbolHeight = symbolTextures[0].height;

  reel.configParams.appertureSpacing = checkForDefined(json.appertureSpacing)
    ? json.appertureSpacing
    : reel.symbolHeight;
  reel.configParams.viewportWidth = checkForDefined(json.viewportWidth)
    ? json.viewportWidth / resourceManager.selectedAssetResolution.scaleFactor
    : reel.symbolWidth;
  reel.configParams.viewportHeight = checkForDefined(json.viewportHeight)
    ? json.viewportHeight / resourceManager.selectedAssetResolution.scaleFactor
    : reel.configParams.appertureSpacing * reel.configParams.appertureHeight;
  reel.configParams.viewportOffsetX =
    (reel.configParams.viewportWidth - reelManager.symbolWidth) / 2;

  if (checkForDefined(json.useContainer)) {
    reel.configParams.useContainer.child = checkForDefined(
      json.useContainer.child
    )
      ? json.useContainer.child
      : reel.configParams.useContainer.child;
  }

  reel.configParams.animationStripWidth = checkForDefined(
    json.animationStripWidth
  )
    ? json.animationStripWidth
    : reel.configParams.viewportWidth;
  reel.configParams.animationStripHeight = checkForDefined(
    json.animationStripHeight
  )
    ? json.animationStripHeight
    : reel.configParams.viewportHeight;

  // Set up background
  if (typeof json.backgroundColour !== "undefined") {
    var backgroundFill = new PIXI.Graphics();
    backgroundFill.beginFill(json.backgroundColour, 1);
    backgroundFill.drawRect(
      0,
      0,
      reel.symbolWidth,
      reel.symbolHeight * reel.configParams.appertureHeight
    );
    backgroundFill.endFill();
    reel.addChildAt(backgroundFill, 0);
  }

  reel.symbolSize = [];

  reel.initialise = function (json) {
    reel.symbolContainer = resourceManager.createObject(
      "container",
      "symbolContainer",
      json.FQN,
      {
        //Move symbols within clip area
        x:
          (reel.configParams.viewportWidth / 2) *
          resourceManager.selectedAssetResolution.scaleFactor,
        y: 0,
      }
    );

    reel.symbolContainer.parent.removeChild(reel.symbolContainer);

    reel.interactiveSymbolContainer = new PIXI.Graphics();
    reel.interactiveSymbolContainer.interactive = true;

    reel.interactiveSymbolContainer.mousedown = function (eventData) {
      //Convert the mouse position to be relative to the reel
      var point = eventData.data.getLocalPosition(this);
      //Get the selected index
      var index = Math.floor(point.y / reel.configParams.appertureSpacing);
      index += reel.configParams.preappertureSymbols;

      //Invoke the mousedown event on the selected symbol
      if (
        reel.symbolSprites[index].symbol.interactive &&
        reel.symbolSprites[index].symbol.mousedown !== undefined
      )
        reel.symbolSprites[index].symbol.mousedown(eventData);
    };

    reel.interactiveSymbolContainer.beginFill(0x000000, 0);
    reel.interactiveSymbolContainer.drawRect(
      0,
      0,
      reel.configParams.viewportWidth,
      reel.configParams.viewportHeight
    );
    reel.addChild(reel.symbolContainer);

    reel.mask = new PIXI.Graphics();
    reel.mask.beginFill(0x000000, 0);
    reel.mask.drawRect(
      0,
      0,
      reel.configParams.viewportWidth + 1,
      reel.configParams.viewportHeight + 1
    );
    reel.mask.endFill();
    reel.addChild(reel.mask);

    // loop through and create reel symbols ( should be 4 for dublin up - 3 in view - one post reels to allow 4 symbols to drop on initial spin)
    for (var i = 0; i < reel.configParams.totalAppertureSize; i++) {
      var newSymbolContainer = resourceManager.createObject(
        "container",
        "symbol" + i,
        reel.symbolContainer.name,
        {
          x: 0,
          y: (i + 0.5) * reel.configParams.appertureSpacing,
        }
      );

      newSymbolContainer.index = i;

      newSymbolContainer.symbol = resourceManager.createObject(
        "movie",
        "symbol",
        newSymbolContainer.name,
        {
          x: 0,
          y: 0,
          definition: "staticSymbols",
          cloneTextures: true,
        }
      );

      if (reel.configParams.useContainer.child) {
        newSymbolContainer.symbol.childContainer = resourceManager.createObject(
          "container",
          "childContainer",
          newSymbolContainer.symbol.name,
          {
            x: 0,
            y: 0,
          }
        );
      }

      newSymbolContainer.dimReelsCanvas = resourceManager.createObject(
        "graphics",
        "dimReelsCanvas",
        newSymbolContainer.name,
        {
          x: 0,
          y: 0,
        }
      );

      newSymbolContainer.dimReelsCanvas.beginFill(0x000000);
      newSymbolContainer.dimReelsCanvas.drawRect(
        -(reel.configParams.viewportWidth + 1) / 2,
        -(reel.configParams.viewportHeight + 1) / 2,
        reel.configParams.viewportWidth + 1,
        reel.configParams.viewportHeight + 1
      );
      newSymbolContainer.dimReelsCanvas.endFill();
      newSymbolContainer.dimReelsCanvas.alpha = 0.6;
      newSymbolContainer.dimReelsCanvas.visible = false;

      newSymbolContainer.symbol.anchor.set(0.5, 0.5);
      newSymbolContainer.symbol.gotoAndStop(initialSymbols[i].symbolId);

      reel.symbolData.push(initialSymbols[i]);
      reel.symbolSprites.push(newSymbolContainer);
      newSymbolContainer.symbol.symbolIndex = i;
      newSymbolContainer.symbol.parentReel = reel;

      // Confirm all files loaded
      for (var j = 0; j < newSymbolContainer.symbol.textures.length; j++) {
        if (!newSymbolContainer.symbol.textures[j].baseTexture.hasLoaded) {
          console.log(
            "Texture index " +
              j +
              " for symbol " +
              Object.keys(resourceManager.getConfiguration().symbols)[j] +
              " was not loaded"
          );
          return;
        }
      }

      // Store original UV'. We only do this for the first symbol in the animation movie, as this is the one we spin past.
      if (i === 0) {
        for (var j = 0; j < newSymbolContainer.symbol.textures.length; j++) {
          reel.symbolSize.push({
            width: newSymbolContainer.symbol.textures[j].frame.width,
            height: newSymbolContainer.symbol.textures[j].frame.height,
          });
        }
      }
    }

    for (var i = 0; i < this.symbolData.length; i++) {
      reel.symbolDropDeltas.push(0);
    }

    if (reel.configParams.useContainer.child) {
      // A container to use as temporary storage when adjusting the symbols as part of getNextSymbolFromInjector
      reel.workingContainer = resourceManager.createObject(
        "container",
        "workingContainer",
        newSymbolContainer.name,
        {
          x: 0,
          y: 0,
        }
      );
    }

    // A container to hold all of the animation strips for this reel
    reel.animationStripContainer = resourceManager.createObject(
      "container",
      "animationStripContainer",
      json.FQN,
      {
        x: 0,
        y: 0,
      }
    );
    reel.animationStripContainer.parent.removeChild(
      reel.animationStripContainer
    );
    reel.animationStripContainer.scale.set(1.0, 1.0);

    /*
        reel.animationStripContainer.mask = new PIXI.Graphics();
        reel.animationStripContainer.mask.beginFill(0x000000, 0);
        reel.animationStripContainer.mask.drawRect(-reel.configParams.viewportWidth / 2, 0, reel.configParams.viewportWidth + 1, reel.configParams.viewportHeight + 1);
        reel.animationStripContainer.mask.endFill();
        reel.animationStripContainer.addChild(reel.animationStripContainer.mask);
        */

    // A container to hold all of the animation box strip for this reel
    reel.animationBoxContainer = resourceManager.createObject(
      "container",
      "animationBoxContainer",
      json.FQN,
      {
        x: 0,
        y: 0,
      }
    );
    reel.animationBoxContainer.parent.removeChild(reel.animationBoxContainer);
  };

  reel.onTouched = function () {
    this.touchedCallback(
      this.parentReel.reelIndex,
      this.symbolIndex - reel.configParams.preappertureSymbols
    );
  };

  reel.setTouchCallback = function (index, callback) {
    index += reel.configParams.preappertureSymbols;
    reel.symbolSprites[index].symbol.interactive = true;
    reel.symbolSprites[index].symbol.mousedown = reel.symbolSprites[
      index
    ].symbol.touchstart = reel.onTouched;
    reel.symbolSprites[index].symbol.touchedCallback = callback;
  };

  reel.clearTouchCallback = function (index) {
    reel.symbolSprites[
      index + reel.configParams.preappertureSymbols
    ].symbol.interactive = false;
  };

  reel.setReelSymbol = function (index, symbolData) {
    var spriteIndex = index + reel.configParams.preappertureSymbols;
    this.clearReelSymbolData(spriteIndex);
    this.setReelSymbolData(spriteIndex, symbolData);
    this.pos = 0.99999;
    this.updateSymbols();
    var symbol = this.symbolData[spriteIndex].ID;

    if (reel.anySymbolCreatedCallback !== undefined) {
      reel.anySymbolCreatedCallback(this.reelIndex, symbol, spriteIndex);
    }
    if (reel.symbolCreatedCallbacks[symbol] !== undefined) {
      reel.symbolCreatedCallbacks[symbol](this.reelIndex, symbol, spriteIndex);
    }
  };

  reel.setSymbol = function (index, symbol) {
    // TODO SA 12/04    index += reel.configParams.preappertureSymbols;
    // Change the symbol and the underlying data
    this.symbolSprites[index].symbol.gotoAndStop(symbol);
    this.symbolData[index].symbolId = symbol;

    if (reel.anySymbolCreatedCallback !== undefined) {
      reel.anySymbolCreatedCallback(this.reelIndex, symbol, index);
    }
    if (reel.symbolCreatedCallbacks[index] !== undefined) {
      reel.symbolCreatedCallbacks[index](this.reelIndex, symbol, index);
    }
  };

  reel.getSymbol = function (index) {
    return this.symbolData[index + reel.configParams.preappertureSymbols]
      .symbolId;
  };

  reel.showSymbol = function (index, show) {
    // var symbolSpriteIndex = index + reel.configParams.preappertureSymbols;
    this.symbolSprites[index].symbol.visible = show;
  };

  // Layer any symbols we want to be on top
  reel.overlayOversizedSymbols = function (index) {
    var symbolId = this.symbolSprites[index].symbol;
    var symbolSprite = this.symbolContainer.children.find(function (element) {
      return element.symbol === symbolId;
    });

    this.symbolContainer.setChildIndex(
      symbolSprite,
      this.symbolContainer.children.length - 1
    );
  };

  reel.setSpinner = function (spinnerFunction) {
    this.updatePos = spinnerFunction.bind(this);
  };

  reel.popSymbols = function (symbolsToPop, newSymbols) {
    timerManager.addTimer(400, undefined, function () {});
    // Note it is up to the game programmer to set the symbols that are dropping in before calling this function
    for (var i = 0; i < this.symbolData.length; i++) {
      this.symbolDropDeltas[i] = 0;
    }

    this.symbolDropDeltas[3] = 0;

    var symbolsPopped = 0;
    var lastSymbolToPopIndex = symbolsToPop.length - 1;
    for (var i = symbolsToPop.length - 1; i >= 0; --i) {
      if (symbolsToPop[i]) {
        symbolsPopped++;
      } else {
        this.symbolDropDeltas[lastSymbolToPopIndex--] = symbolsPopped;
      }
    }

    // Fill in all the above symbols so they are also dropped
    for (var i = 0; i <= lastSymbolToPopIndex; ++i) {
      this.symbolDropDeltas[i] = symbolsPopped;
    }

    // how many symbols are we popping on this reel - needed to calc the new position to drop from
    var numTrue = 0;
    for (var i = 0; i < 3; i++) {
      if (symbolsToPop[i] === true) {
        numTrue++;
      }
    }

    // for symbols that are popping we move them above the visible reel frame ready to drop in
    var index = numTrue;
    for (var i = 0; i < 3; i++) {
      if (symbolsToPop[i] === true) {
        this.symbolSprites[i].position.setY(
          0.5 * this.configParams.appertureSpacing +
            -index * this.configParams.appertureSpacing
        );
        index--;
      }
    }

    // the 4th unused except for initial drop - set Y way out of bounds for sort - though this position should be at the end anyway
    this.symbolSprites[3].position.setY(1000);

    // sort the sprites and symbol data - any popped symbols are now in the correct order
    for (var i = 0; i < this.symbolSprites.length; i++) {
      for (var j = 0; j < this.symbolSprites.length - i - 1; j++) {
        if (
          this.symbolSprites[j].position.getY() >
          this.symbolSprites[j + 1].position.getY()
        ) {
          var temp = this.symbolSprites[j];
          this.symbolSprites[j] = this.symbolSprites[j + 1];
          this.symbolSprites[j + 1] = temp;

          var tempData = this.symbolData[j];
          this.symbolData[j] = this.symbolData[j + 1];
          this.symbolData[j + 1] = tempData;
        }
      }
    }

    // set the symbols now all are in their new positions.
    for (var i = 0; i < 3; i++) {
      this.setSymbol(i, newSymbols[i]._id);
    }

    // store the starting y positions before the drop
    for (var i = 0; i < this.symbolSprites.length; i++) {
      this.currentYPos[i] = this.symbolSprites[i].position.getY();
      this.symbolSprites[i].alpha = 1.0; // SA We must turn symbols back on here - lucky lose modifier turns them off

      this.posForOrientation[i] = undefined;
    }
  };

  reel.dropSymbols = function (delay, symbolsToPop, completeCallback) {
    // Use popSymbls before calling dropSymbols
    this.popAndDropComplete = completeCallback;

    this.dropCount = 4;

    let self = this;
    timerManager.addTimer(
      delay,
      function (progress) {},
      function () {
        let soundIndex = Math.floor(Math.random() * reel._cascadeSounds.length);
        // soundManager.play(reel._cascadeSounds[soundIndex]);
        self.stateMachine.switchState("POP_AND_DROP");
      }
    );
    //this.stateMachine.switchState("POP_AND_DROP");
  };

  reel.popAndDrop = function (symbolsToPop, completeCallback) {
    reel.popSymbols(symbolsToPop);
    reel.dropSymbols(symbolsToPop, completeCallback);
  };

  reel.dimSymbol = function (index, dim, duration, tint) {
    var children;
    if (dim) {
      tint = checkForDefined(tint) ? tint : 0x777777;
    } else {
      tint = 0xffffff;
    }

    if (systemData.renderer instanceof PIXI.CanvasRenderer) {
      this.symbolSprites[index].dimReelsCanvas.visible = tint != 0xffffff;
    } else {
      this.symbolSprites[index].symbol.tint = tint;

      if (checkForDefined(this.symbolSprites[index].symbol.childContainer)) {
        children = this.symbolSprites[index].symbol.childContainer.children;
        for (var i = 0; i < children.length; i++) {
          const symbol = children[i];

          gsap.to(symbol, {
            duration,
            pixi: { tint: targetTint },
          });
        }
      }
    }
  };

  reel.dimAllSymbols = function (dim, duration = 0.3) {
    for (var i = 0; i < reel.configParams.totalAppertureSize; i++) {
      reel.dimSymbol(i, dim, duration);
    }
  };

  reel.linkAnimation = function (animationStrip, animationStripID) {
    reel.linkedAnimations.push(animationStrip);
    resourceManager.setParent(animationStrip, this.animationStripContainer);
  };

  reel.linkReelBoxStrip = function (animationStrip, animationStripID) {
    reel.linkedReelBoxStrips.push(animationStrip);
    resourceManager.setParent(animationStrip, this.animationBoxContainer);
  };

  reel.updateSymbols = function () {
    // Set symbols
    for (var i = 0; i < reel.configParams.totalAppertureSize; i++) {
      this.symbolSprites[i].symbol.gotoAndStop(this.symbolData[i].symbolId);
    }

    // Move container
    var posOffset = 0;
    var animationStripOffset = 0;

    posOffset =
      (this.pos + (reel.configParams.preappertureSymbols - 1)) *
      reel.configParams.appertureSpacing;
    animationStripOffset = (this.pos - 1) * reel.configParams.appertureSpacing;

    //Move symbols within clip area
    this.symbolContainer.position.setY(-posOffset);
    this.interactiveSymbolContainer.scale.set(1.0, 1.0);

    // Align animation box and strip with reels
    this.animationBoxContainer.position.set(
      this.position.x * resourceManager.selectedAssetResolution.scaleFactor,
      this.position.y * resourceManager.selectedAssetResolution.scaleFactor
    );

    this.animationBoxContainer.scale.set(this.scale.x, this.scale.y);

    this.animationStripContainer.position.set(
      (this.position.x * (1.0 / this.scale.x) + this.symbolWidth * 0.5) *
        resourceManager.selectedAssetResolution.scaleFactor,
      this.position.y *
        (1.0 / this.scale.y) *
        resourceManager.selectedAssetResolution.scaleFactor -
        animationStripOffset
    );
    //this.animationStripContainer.scale.set(this.scale.x, this.scale.y);
  };

  reel.expandAnimationClipRect = function () {
    var offsetX =
      (this.configParams.animationStripWidth -
        reel.configParams.viewportWidth) /
      2;
    var offsetY =
      (this.configParams.animationStripHeight -
        reel.configParams.viewportHeight) /
      2;

    reel.mask.clear();
    reel.mask.beginFill(0xffff00, 0.5);
    reel.mask.drawRect(
      -offsetX,
      -offsetY,
      this.configParams.animationStripWidth + 1,
      this.configParams.animationStripHeight + 1
    );
    reel.mask.endFill();
  };

  reel.restoreAnimationClipRect = function () {
    reel.mask.clear();
    reel.mask.beginFill(0xffff00, 0.5);
    reel.mask.drawRect(
      0,
      0,
      reel.configParams.viewportWidth + 1,
      reel.configParams.viewportHeight + 1
    );
    reel.mask.endFill();
  };

  reel.clearReelSymbolData = function (index) {
    // Delete child from child contianer
    if (this.configParams.useContainer.child) {
      var children = this.symbolSprites[index].symbol.childContainer.children;
      while (children.length > 0) {
        resourceManager.destroyObject(children[0].name);
      }
    }
  };

  reel.setReelSymbolData = function (index, data) {
    if (typeof data === "number") {
      data = {
        symbolId: data,
      };
    } else if (typeof data === "string") {
      data = {
        symbolId: Number(data),
      };
    }

    if (data.childData === undefined) {
      if (this.preInjector !== undefined) {
        data.childData = this.preInjector.getSymbolChildData(data.symbolId);
      }
    }

    var configSymbols = resourceManager.getConfiguration().symbols;
    var configKeys = Object.keys(configSymbols);
    for (var i = 0; i < configKeys.length; ++i) {
      if (configSymbols[configKeys[i]].ID === data.symbolId) {
        var symbolKeys = Object.keys(configSymbols[configKeys[i]]);
        for (var j = 0; j < symbolKeys.length; ++j) {
          if (data[symbolKeys[j]] === undefined) {
            data[symbolKeys[j]] = configSymbols[configKeys[i]][symbolKeys[j]];
          }
        }
      }
    }

    if (data.oversized === undefined) data.oversized = false;

    if (data.childData !== undefined && data.childData.length > 0) {
      for (var i = 0; i < data.childData.length; ++i) {
        resourceManager.createObject(
          data.childData[i].type,
          data.childData[i].name + i,
          this.symbolSprites[index].symbol.childContainer.name,
          data.childData[i].json
        );
      }
    }
    if (data.oversized === true) {
      var symbolId = this.symbolSprites[index].symbol;
      var symbolSprite = this.symbolContainer.children.find(function (element) {
        return element.symbol === symbolId;
      });
      this.symbolContainer.setChildIndex(
        symbolSprite,
        this.symbolContainer.children.length - 1
      );
    }

    // Overides data and sets symbol
    this.symbolData[index] = data;
  };

  reel.symbolCreatedCallbacks = {};
  //callback = function(reelIndex, symbolId)
  reel.setAnySymbolCreatedCallback = function (callback) {
    reel.anySymbolCreatedCallback = callback;
  };

  //callback = function(reelIndex, symbolId)
  reel.setSymbolCreatedCallback = function (symbolId, callback) {
    reel.symbolCreatedCallbacks[symbolId] = callback;
  };

  reel.symbolDeletedCallbacks = {};
  //callback = function(reelIndex, symbolId)
  reel.setAnySymbolDeletedCallback = function (callback) {
    reel.anySymbolDeletedCallback = callback;
  };

  //callback = function(reelIndex, symbolId)
  reel.setSymbolDeletedCallback = function (symbolId, callback) {
    reel.symbolDeletedCallbacks[symbolId] = callback;
  };

  reel._getSymbol = function (index) {
    var defaultIndex = this.spinParams.reverseSpin
      ? reel.configParams.totalAppertureSize - 1
      : 0;
    index = index === undefined ? defaultIndex : index;

    var container = this.symbolContainer.children.find(function (element) {
      return element.index === index;
    });
    return container;
  };

  reel.getSymbolContainer = function (index) {
    return this._getSymbol(index).symbol;
  };

  reel.getSymbolChildContainer = function (index) {
    return this._getSymbol(index).symbol.childContainer;
  };

  reel.update = function (delta) {
    this._updateDelta = delta;
    this.Props.stateTime -= delta;
    this.stateMachine.update();
  };

  reel.updatePos = cascadeReelTemplate.defaultSpin;
  reel.updateNudge = cascadeReelTemplate.nudge;
  reel.updatePopAndDrop = cascadeReelTemplate.popAndDrop;
  reel.clearSymbols = cascadeReelTemplate.clearSymbols;
  reel.dropInitialSymbols = cascadeReelTemplate.dropInitialSymbols;

  reel._landSound = "symbolLand0";

  reel._updateDelta = 0.0;

  StateMachine.Create(reel);

  reel.stateMachine.addState("READY", function state_ready() {}.bind(reel));

  //
  // reel.stateMachine.addState("POP_AND_DROP", function state_popanddrop() {
  //     if (this.phase.enter()) {

  //     }
  //     if (this.phase.timed(this.configParams.popAndDropTime)) {
  //         this.updatePopAndDrop(this.phase.Progress);
  //     }
  //     if (this.phase.once()) {
  //         this.stateMachine.switchState("READY");
  //     }
  //     if (this.phase.exit()) {
  //         this.updatePopAndDrop(1);
  //         this.updateSymbols();
  //         this.popAndDropComplete();
  //     }
  // }.bind(reel));

  reel.stateMachine.addState(
    "POP_AND_DROP",
    function state_popanddrop() {
      if (this.phase.enter()) {
      }

      // we need to drop the symbols off one by one
      if (this.phase.once()) {
        let gap = freespins.inFreespins
          ? this.configParams.gapBetweenSymbolsFS
          : this.configParams.gapBetweenSymbols;
        this.popDropSymbol(0 * gap, 3);
        this.popDropSymbol(1 * gap, 2);
        this.popDropSymbol(2 * gap, 1);
        this.popDropSymbol(3 * gap, 0);
      }

      if (this.phase.hold()) {
        if (this.dropCount === 0) {
          this.phase.step();
        }
      }

      if (this.phase.once()) {
        this.stateMachine.switchState("READY");
      }
      if (this.phase.exit()) {
        //this.spinning = false;
        this.updateSymbols();
        this.popAndDropComplete();
      }
    }.bind(reel)
  );

  reel.stateMachine.addState(
    "CLEARSYMBOLS",
    function state_clearSymbols() {
      if (this.phase.enter()) {
      }

      // we need to drop the symbols off one by one
      if (this.phase.once()) {
        let gap = freespins.inFreespins
          ? this.configParams.gapBetweenSymbolsFS
          : this.configParams.gapBetweenSymbols;
        this.clearSymbol(0 * gap, 3);
        this.clearSymbol(1 * gap, 2);
        this.clearSymbol(2 * gap, 1);
        this.clearSymbol(3 * gap, 0);
      }

      if (this.phase.hold()) {
        if (this.dropCount === 0) {
          this.phase.step();
        }
      }

      if (this.phase.once()) {
        this.stateMachine.switchState("READY");
      }
      if (this.phase.exit()) {
        this.spinning = false;

        this.initialDropCompleteCallback(this.reelIndex);
      }
    }.bind(reel)
  );

  reel.popDropSymbol = function (timeBetweenSymbols, symbolIndex) {
    let self = this;
    let dropTime = freespins.inFreespins
      ? this.configParams.dropSingleTimeFS
      : this.configParams.dropSingleTime;

    timerManager.addTimer(
      timeBetweenSymbols,
      function (progress) {},
      function () {
        timerManager.addTimer(
          dropTime,
          function (progress) {
            self.updatePopAndDrop(symbolIndex, progress);
          },
          function () {
            self.dropCount--;
            self.updatePopAndDrop(symbolIndex, 1);
          }
        );
      }
    );
  };

  reel.clearSymbol = function (timeBetweenSymbols, symbolIndex) {
    let self = this;
    let dropTime = freespins.inFreespins
      ? this.configParams.dropAllTimeFS
      : this.configParams.dropAllTime;

    self.clearTimer[symbolIndex] = timerManager.addTimer(
      timeBetweenSymbols,
      function (progress) {},
      function () {
        self.clearSymTimer[symbolIndex] = timerManager.addTimer(
          dropTime,
          function (progress) {
            self.clearSymbols(symbolIndex, progress);
          },
          function () {
            self.dropCount--;
            self.clearSymbols(symbolIndex, 1);
          }
        );
      }
    );
  };

  reel.dropSymbol = function (timeBetweenSymbols, symbolIndex) {
    // this is the initial drop of symbols after the reels are cleared away
    let self = this;
    let dropTime = freespins.inFreespins
      ? this.configParams.dropAllTimeFS
      : this.configParams.dropAllTime;

    self.symTimer[symbolIndex] = timerManager.addTimer(
      timeBetweenSymbols,
      function () {},
      function () {
        timerManager.addTimer(
          dropTime * 0.8,
          function () {},
          function () {
            if (self.reelIndex === 0 && symbolIndex === 0) {
              soundManager.play(reel._landSound);
            }
          }
        );

        self.dropInitialTimer[symbolIndex] = timerManager.addTimer(
          dropTime,
          function (progress) {
            self.dropInitialSymbols(symbolIndex, progress);
          },
          function () {
            self.dropInitialSymbols(symbolIndex, 1);

            // we don't need to worry about the bottom most symbol as that never lands on screen
            if (symbolIndex !== 3) {
              self._landedCallback(self.reelIndex, symbolIndex);
            }

            // do drop count after callback to ensure any anims have been started
            self.dropCount--;
          }
        );
      }
    );
  };

  reel.stateMachine.addState(
    "DROPINITIALSYMBOLS",
    function state_dropInitialSymbols() {
      if (this.phase.enter()) {
      }

      // ?? allowDrop = [true, false, false ];

      // we need to drop the symbols off one by one
      if (this.phase.once()) {
        let gap = freespins.inFreespins
          ? this.configParams.gapBetweenSymbolsFS
          : this.configParams.gapBetweenSymbols;

        this.dropSymbol(0 * gap, 3);
        this.dropSymbol(1 * gap, 2);
        this.dropSymbol(2 * gap, 1);
        this.dropSymbol(3 * gap, 0);
      }

      if (this.phase.hold()) {
        // if ( this.dropCount === 3 ) {
        //     reel.alpha = 1;
        // }

        if (this.dropCount === 0) {
          this.phase.step();
        }
      }

      if (this.phase.once()) {
        if (this.reelIndex === 4) {
          const self = this;
          timerManager.addTimer(400, undefined, function () {
            self.stateMachine.switchState("READY");
          });
        }
      }

      // Make sure the callback handler checks that we haven't already been invoked
      // in this case it works by setting boolean flags rather than a count that can be
      // decremented too many times
      if (this.phase.once()) {
        const self = this;
        // add a little delay before spinning if we are in free spins or autoplay
        timerManager.addTimer(
          freespins.inFreespins || autoplayManager.isAutioplayEnabled ? 850 : 0,
          undefined,
          function () {
            self.spinning = false;
            self.spinCompleteCallback(this.reelIndex);
          }
        );
      }
    }.bind(reel)
  );

  reel.onOrientationChange = function () {
    for (var i = 0; i < this.symbolSprites.length; i++) {
      if (reel.posForOrientation[i] !== undefined) {
        this.symbolSprites[i].position.setY(reel.posForOrientation[i]);
      }
    }
  };

  Reflex.registerEventHandler(
    "orientationChange",
    reel.onOrientationChange.bind(reel)
  );

  reel.stateMachine.switchState("READY");

  return reel;
};
